import { Injectable } from '@angular/core';

@Injectable()
export class CardService {

  constructor() { }

     checkNumber(number) {
         const val = this.GetCardType(number);
         return val;
    }

     GetCardType(number) {
        let re = new RegExp('^4');
        if (number.match(re) != null) {
            return 'visa';
        }
        re = new RegExp('^(34|37)');

        if (number.match(re) != null) {
            return 'americanexpress';
        }
        re = new RegExp('^5[1-5]');

        if (number.match(re) != null) {
            return 'mastercard';
        }
        re = new RegExp('^6011');

        if (number.match(re) != null) {
            return 'discover';
        }

        return '';
    }
}
